import { render } from "./Main.vue?vue&type=template&id=5dff3874&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=5dff3874&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5dff3874"

export default script